import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4671d9e0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4671d9e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4671d9e0",
  null
  
)

export default component.exports